import { Navigate, useLocation } from 'react-router-dom';

/** Non-breaking /pm/* aliases → legacy Plan routes (e.g. /pm/board → /board). */
export default function PmPathRedirect() {
  const location = useLocation();
  const stripped = location.pathname.replace(/^\/pm\/?/, '');
  const targetPath = stripped ? `/${stripped}` : '/dashboard';
  return <Navigate to={`${targetPath}${location.search}${location.hash}`} replace />;
}
